import { Link } from "react-router-dom";

import { AncetTable, transformAncet } from "@/features/chats";
import { useAdminChatOutlet } from "./AdminChatUserLayout";

import styles from "./AdminChatAncetPage.module.scss";

export const AdminChatAncetPage = () => {
  const { profile } = useAdminChatOutlet();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Link to=".." className={styles.back}>
          ← Назад к клиенту
        </Link>
        <h3>Анкета клиента</h3>
        <span className={styles.placeholder} />
      </div>

      <AncetTable items={transformAncet(profile.ancet ?? [])} />
    </div>
  );
};

